import React from "react";
import Table from "../../../components/Table";
import { KredietInfo } from "../../../../../.generated/rapportage/rapportagetypes";
import { getKredietenColumns } from "../../Producten/kredieten-kolommen";

export interface SingleKredietTableProps {
  data: KredietInfo;
}

export interface KredietenTableProps {
  data: KredietInfo[];
}

export const SingleKredietTable: React.FC<SingleKredietTableProps> = ({
  data,
}: SingleKredietTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getKredietenColumns(true)}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`krediet-table-${data.geldverstrekker
          ?.replace(/\s+/g, "-")
          .toLowerCase() || "krediet"}`}
      />
    </div>
  );
};

export const KredietenTable: React.FC<KredietenTableProps> = ({
  data,
}: KredietenTableProps) => {
  return (
    <div className="kredieten-section">
      {data.map((krediet, index) => (
        <SingleKredietTable key={index} data={krediet} />
      ))}
    </div>
  );
};
